import { usePlans } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { isPlanBasic, isPlanEnterprise } from "@/react/helpers/planHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

import { GrandfatheredDowngradeWarning } from "./GrandfatheredDowngradeWarning";
import { MarketingCampaignBanner } from "./MarketingCampaignBanner";
import { PlanTrialBanner } from "./PlanTrialBanner";
import { PlanTrialOptInBanner } from "./PlanTrialOptInBanner";
import { ScheduledSubscriptionBanner } from "./ScheduledSubscriptionBanner";
import { SubscriptionStatusBanner } from "./SubscriptionStatusBanner";
import { TrialCreditsBanner } from "./TrialCreditsBanner";

export const TopSection = () => {
  const { currentPlan } = usePlans();
  const { currentCommunity } = usePunditUserContext();

  const { isExpiredTrial, isCommunityOnTrial, hasActiveOffer } =
    usePlanStatus();

  const shouldRenderGrandFatheredBanner =
    currentPlan &&
    (currentPlan.show_pro_grandfathered_for_courses ||
      (isPlanEnterprise(currentPlan.tier) && !currentPlan.public) ||
      isPlanBasic(currentPlan.tier)) &&
    !isExpiredTrial &&
    !isCommunityOnTrial;

  if (!currentCommunity) {
    return null;
  }

  const isCommunityHubDowngradeScheduled =
    currentPlan?.is_community_hub_downgrade_scheduled;

  if (isCommunityHubDowngradeScheduled) {
    return <ScheduledSubscriptionBanner currentPlan={currentPlan} />;
  }

  return (
    <>
      <PlanTrialOptInBanner />
      <PlanTrialBanner />
      <TrialCreditsBanner />
      {shouldRenderGrandFatheredBanner && (
        <GrandfatheredDowngradeWarning currentPlan={currentPlan} />
      )}
      <SubscriptionStatusBanner />
      {hasActiveOffer && <MarketingCampaignBanner />}
    </>
  );
};
